import { render } from "./HealthcareHeaderSection.vue?vue&type=template&id=11ebcc89"
import script from "./HealthcareHeaderSection.vue?vue&type=script&lang=js"
export * from "./HealthcareHeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__